module.exports = __webpack_public_path__ + "static/ciudad-zombie-a95b013846443d09b38a0503e6369f82.png";